import { render, staticRenderFns } from "./_dialogMessage.vue?vue&type=template&id=054d572b&"
import script from "./_dialogMessage.vue?vue&type=script&lang=ts&"
export * from "./_dialogMessage.vue?vue&type=script&lang=ts&"
import style0 from "./_dialogMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports